var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"closeButton",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"fal fa-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }